(function () {
    const MARKET_COOKIE_NAME = "preferred_market";
    const AUTO_SELECT_MARKET_FIRST_TIME_COOKIE_NAME =
        "auto_select_market_first_time";
    const MARKET_EXPIRY_DAYS = 30;
    const MARKET_PREFIXES = [
        "fr-fr",
        "en",
        "en-row",
        "de-de",
        "en-de",
        "fr-ch",
        "de-ch",
        "en-ch",
        "en-gb",
        "en-roe",
        "de-roe",
        "fr-roe",
        "en-au",
        "en-us",
        "en-ca",
        "fr-ca",
        "ja-jp",
        "en-jp",
        "en-row",
    ];
    const MARKET_GROUPS = {
        fr: {
            prefixes: ["fr-fr", "en"],
            name: "France",
        },
        de: {
            prefixes: ["de-de", "en-de"],
            name: "Germany/ Austria",
        },
        ch: {
            prefixes: ["fr-ch", "de-ch", "en-ch"],
            name: "Switzerland",
        },
        gb: {
            prefixes: ["en-gb"],
            name: "the United Kingdom",
        },
        roe: {
            prefixes: ["en-roe", "de-roe", "fr-roe"],
            name: "the Rest of Europe",
        },
        au: {
            prefixes: ["en-au"],
            name: "Australia",
        },
        us: {
            prefixes: ["en-us"],
            name: "the United States",
        },
        ca: {
            prefixes: ["fr-ca", "en-ca"],
            name: "Canada",
        },
        jp: {
            prefixes: ["ja-jp", "en-jp"],
            name: "Japan",
        },
        row: {
            prefixes: ["en-row"],
            name: "the Rest of World",
        },
    };

    const currentPath = window.location.pathname;
    const pathParts = currentPath.split("/");
    const currentPrefix = isMarketPrefix(pathParts[1]) ? pathParts[1] : "fr-fr";
    const redirectBaseUrl = window.location.origin;
    const currentSearchParam = window.location.search;

    function setCookie(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()};SameSite=Lax`;
    }

    function getMarketName(marketCode) {
        return MARKET_GROUPS[marketCode]?.name;
    }

    function getCookie(name) {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
            const c = cookies[i].trim();
            if (c.indexOf(name + "=") === 0) {
                return c.substring((name + "=").length, c.length);
            }
        }
        return null;
    }

    function isMarketPrefix(pathSegment) {
        return MARKET_PREFIXES.includes(pathSegment);
    }

    function redirectToMarket(market, pathSuffix) {
        let newUrl = redirectBaseUrl;

        if (market != "fr-fr") {
            newUrl = newUrl + "/" + market;
        }
        if (pathSuffix !== "/") {
            newUrl = newUrl + pathSuffix;
        }
        window.location.href = newUrl + currentSearchParam;
    }

    function getPathWithoutPrefix(prefix, path) {
        if (prefix != "fr-fr") {
            return path.replace(`/${prefix}`, "") || "/";
        }
        return path;
    }
    function getMarketOfPrefix(prefix) {
        for (const [marketCode, { prefixes }] of Object.entries(
            MARKET_GROUPS
        )) {
            if (prefixes.includes(prefix)) return marketCode;
        }
        return null;
    }
    function isSameMarket(prevPrefix, newPrefix) {
        const prevMarketCode = getMarketOfPrefix(prevPrefix);
        const newMarketCode = getMarketOfPrefix(newPrefix);
        return prevMarketCode === newMarketCode ? true : false;
    }
    // Auto select market first time
    const isAutoSelectMarketFirstTime = getCookie(
        AUTO_SELECT_MARKET_FIRST_TIME_COOKIE_NAME
    );
    if (!isAutoSelectMarketFirstTime) {
        setCookie(
            AUTO_SELECT_MARKET_FIRST_TIME_COOKIE_NAME,
            1,
            MARKET_EXPIRY_DAYS
        );
        return;
    }

    // Auto redirect logic
    const preferredMarket = getCookie(MARKET_COOKIE_NAME);

    if (!preferredMarket) {
        setCookie(MARKET_COOKIE_NAME, currentPrefix, MARKET_EXPIRY_DAYS);
    } else if (preferredMarket !== currentPrefix) {
        if (!isSameMarket(preferredMarket, currentPrefix)) {
            const suffix = getPathWithoutPrefix(currentPrefix, currentPath);
            redirectToMarket(preferredMarket, suffix);
        } else {
            setCookie(MARKET_COOKIE_NAME, currentPrefix, MARKET_EXPIRY_DAYS);
        }
    }

    function submitSwitchMarket(el) {
        if(el instanceof Element) {
            const form = el.closest("#localization_form");
            let countryInputEl = form.querySelector("input[name='country_code']");
            let localeInputEl = form.querySelector("input[name='locale_code']");

            if (!countryInputEl) {
                countryInputEl = document.createElement("input");
                countryInputEl.type = "hidden";
                countryInputEl.name = "country_code";
                countryInputEl.value = el.dataset.isoCode;
                form.appendChild(countryInputEl);
            } else {
                countryInputEl.value = el.dataset.isoCode;
            }

            if (!localeInputEl) {
                localeInputEl = document.createElement("input");
                localeInputEl.type = "hidden";
                localeInputEl.name = "locale_code";
                localeInputEl.value = el.dataset.defaultLocale;
                form.appendChild(localeInputEl);
            } else {
                localeInputEl.value = el.dataset.defaultLocale;
            }

            form?.submit();
        }
    }

    // Set cookie again on manual selector
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".store-switcher").forEach((el) => {
            el.addEventListener("click", function (e) {
                e.preventDefault();
                const detectedMarket = isMarketPrefix(el.pathname.split("/")[1])
                    ? el.pathname.split("/")[1]
                    : "fr-fr";
                const preferredMarket = getCookie(MARKET_COOKIE_NAME);
                const detectedMarketCode = getMarketOfPrefix(detectedMarket);
                const preferredMarketCode = getMarketOfPrefix(preferredMarket);
                if (detectedMarketCode === preferredMarketCode) return;

                const popupElement = document.querySelector(
                    ".confirm-switch-market"
                );
                if (popupElement) {
                    const confirmFromMarketEl = popupElement.querySelector(
                        ".confirm-text .from-market"
                    );
                    confirmFromMarketEl.textContent =
                        getMarketName(preferredMarketCode);
                    const confirmToMarketEl = popupElement.querySelector(
                        ".confirm-text .to-market"
                    );
                    confirmToMarketEl.textContent =
                        getMarketName(detectedMarketCode);

                    popupElement.classList.remove("hidden");
                    popupElement
                        .querySelector(".confirmed-button")
                        .addEventListener("click", () => {
                            const suffix = getPathWithoutPrefix(
                                detectedMarket,
                                el.pathname
                            );
                            setCookie(
                                MARKET_COOKIE_NAME,
                                detectedMarket,
                                MARKET_EXPIRY_DAYS
                            );
                            submitSwitchMarket(el);
                        });
                }
                return;
            });
        });
    });
})();
